import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import {
  MsalService,
  MsalBroadcastService,
  MSAL_GUARD_CONFIG,
  MsalGuardConfiguration,
} from '@azure/msal-angular';
import {
  AuthenticationResult,
  InteractionType,
  PopupRequest,
  RedirectRequest,
} from '@azure/msal-browser';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { GlobalService } from '../../../core/services/global.service';
import { AppConst } from '../../../../assets/shared.constant';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnInit, OnDestroy {
   
  
  isCollapsed = false;
  app_title = 'HRIS Data Admission Portal';

  isIframe = false;
  private readonly _destroying$ = new Subject<void>();
  userName: any;
  userLoggedIn = false;

  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private msalInstance: MsalService,
    private router: Router,
    private globalService: GlobalService
  ) {}

  async ngOnInit(): Promise<void> {
    const userDetails = this.globalService.getUserDetails();

    this.userName = userDetails.name ? userDetails.name : userDetails.email;

    this.userLoggedIn = userDetails ? true : false;
    var request = new XMLHttpRequest();
      request.open('GET', '../assets/appSettings.svg', false); // request application settings synchronous
      request.send(null);
      const settings = JSON.parse(request.responseText);
      AppConst.authority = settings.authority;
      AppConst.baseURL = settings.baseURL;
      
      if(AppConst.baseURL.includes('dev'))
      {
        this.app_title = this.app_title + ' - Dev'
      }
      if(AppConst.baseURL.includes('app-s'))
        {
          this.app_title = this.app_title + ' - Stage'
        }
        if(AppConst.baseURL.includes('appt'))
          {
            this.app_title = this.app_title + ' - Test'
          }
          
  }

  goToHome() {
    let admin = this.globalService.userType.getValue();
    if (admin) {
      this.router.navigate(['/admin/dashboard']);
    } else {
      this.router.navigate(['/requester/dashboard']);
    }
  }

  async initialize() {
    this.msalInstance.initialize();
  }

  login() {
    if (this.msalGuardConfig.interactionType === InteractionType.Popup) {
      if (this.msalGuardConfig.authRequest) {
        this.authService
          .loginPopup({ ...this.msalGuardConfig.authRequest } as PopupRequest)
          .subscribe((response: AuthenticationResult) => {
            this.authService.instance.setActiveAccount(response.account);
          });
      } else {
        this.authService
          .loginPopup()
          .subscribe((response: AuthenticationResult) => {
            this.authService.instance.setActiveAccount(response.account);
          });
      }
    } else {
      if (this.msalGuardConfig.authRequest) {
        this.authService.loginRedirect({
          ...this.msalGuardConfig.authRequest,
        } as RedirectRequest);
      } else {
        this.authService.loginRedirect();
      }
    }
  }

  logout() {
    const activeAccount =
      this.authService.instance.getActiveAccount() ||
      this.authService.instance.getAllAccounts()[0];

    if (this.msalGuardConfig.interactionType === InteractionType.Popup) {
      this.authService.logoutPopup({
        account: activeAccount,
      });
    } else {
      this.authService.logoutRedirect({
        account: activeAccount,
      });
    }
  }

  // unsubscribe to events when component is destroyed
  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }
}
